<ng-container *ngIf="dialogState === 'DEFAULT'">
    <h1 mat-dialog-title data-automation="changePrimaryOrgDialogTitle">
        {{ 'user.dialog.change_primary_org.title' | translate }}
    </h1>
    <div mat-dialog-content>
        <p class="subtitle" data-automation="changePrimaryOrgDialogSubtitle">
            {{ 'user.dialog.change_primary_org.subtitle' | translate }}
        </p>

        <mat-form-field appearance="outline" class="org-select">
            <mat-label>{{ 'user.dialog.change_primary_org.org_label' | translate }}</mat-label>
            <input
                type="text"
                matInput
                [formControl]="orgControl"
                [matAutocomplete]="auto"
                data-automation="changePrimaryOrgInput"
            />
            <mat-spinner *ngIf="loadingOrgs" matSuffix diameter="18" data-automation="orgsLoading"></mat-spinner>
            <mat-autocomplete
                #auto="matAutocomplete"
                class="change-primary-org-autocomplete"
                [displayWith]="displayOrg"
                (optionSelected)="onOrgSelected($event)"
            >
                <mat-option
                    *ngFor="let org of filteredOrgs$ | async"
                    [value]="org"
                    [disabled]="org.isCurrent"
                    [class.current-org]="org.isCurrent"
                    [attr.data-automation]="'org-' + org.id"
                >
                    <span class="org-option-label">{{ org.display_label }}</span>
                    <mat-icon *ngIf="org.isCurrent" class="current-check">check</mat-icon>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div class="update-roles-row">
            <mat-checkbox [(ngModel)]="updateRoles" data-automation="updateRolesCheckbox">
                {{ 'user.dialog.change_primary_org.update_roles' | translate }}
            </mat-checkbox>
            <mat-icon
                class="tooltip-icon"
                data-automation="changePrimaryOrgUpdateRolesTooltip"
                matTooltip="{{ 'user.dialog.change_primary_org.update_roles_tooltip' | translate }}"
                >info_outline</mat-icon
            >
        </div>

        <p class="subscriptions-warning" data-automation="subscriptionsWarning">
            <mat-icon class="icon-failed">warning_amber</mat-icon>
            <span>{{ 'user.dialog.change_primary_org.subscriptions_warning' | translate }}</span>
        </p>
    </div>
    <div mat-dialog-actions>
        <button class="x-btn-secondary dialog-secondary" aria-label="Cancel" (click)="onCancel()" data-automation="dialogCancel">
            <span>{{ 'user.button.cancel' | translate }}</span>
        </button>

        <button
            class="x-btn-primary dialog-primary"
            aria-label="Confirm"
            (click)="confirm()"
            [disabled]="!selectedOrg"
            data-automation="changePrimaryOrgDialogConfirm"
        >
            <span>{{ 'user.dialog.change_primary_org.confirm' | translate }}</span>
        </button>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'UPDATING'">
    <div mat-dialog-content>
        <div class="dialog-spinner">
            <div class="spinner-container">
                <mat-spinner diameter="24"></mat-spinner>
            </div>
            <span data-automation="changePrimaryOrgDialogTextUpdating">{{ 'user.dialog.change_primary_org.updating' | translate }}</span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'SUCCESS'">
    <div mat-dialog-content>
        <div class="dialog-result">
            <mat-icon class="icon-success">task_alt</mat-icon>
            <span data-automation="changePrimaryOrgDialogTextSuccess">{{ 'user.dialog.change_primary_org.success' | translate }}</span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'FAILED_ORG'">
    <div mat-dialog-content>
        <div class="dialog-result">
            <mat-icon class="icon-failed">warning_amber</mat-icon>
            <span data-automation="changePrimaryOrgDialogTextError">{{ 'user.dialog.change_primary_org.error_org' | translate }}</span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'FAILED_ROLES'">
    <div mat-dialog-content>
        <div class="dialog-result">
            <mat-icon class="icon-failed">warning_amber</mat-icon>
            <span data-automation="changePrimaryOrgDialogTextErrorRoles">{{ 'user.dialog.change_primary_org.error_roles' | translate }}</span>
        </div>
    </div>
</ng-container>
